import React from 'react';

const IcArrowOnlyDirection = () => {
    return (
        <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M10.005 6.50483C9.73161 6.7782 9.73161 7.22141 10.005 7.49478L14.51 11.9998L10.005 16.5048C9.73161 16.7782 9.73161 17.2214 10.005 17.4948C10.2783 17.7681 10.7216 17.7681 10.9949 17.4948L15.9949 12.4948C16.2683 12.2214 16.2683 11.7782 15.9949 11.5048L10.9949 6.50483C10.7216 6.23146 10.2783 6.23146 10.005 6.50483Z'
                fill='#989BA2'
            />
        </svg>
    );
};

export default IcArrowOnlyDirection;
